import {
  SET_POST_LOGIN_REDIRECT,
  LOGIN
} from '@/store/constants'

import store from '@/store'

export default {
  loginRequired (to, from, next) {
    if (to.query.t) {
      // console.log(to.query.t)
      let token = to.query.t
      let payload = { access_token: token }
      store.dispatch(LOGIN, payload)
    }
    if (!store.state.application.token) {
      if (['/logout', '/login'].indexOf(to.path) === -1) {
        store.commit(SET_POST_LOGIN_REDIRECT, to.path)
      }
      return next('/login')
    }
    return next()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Auth.js